import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-social-menu',
  templateUrl: './social-menu.component.html',
  styleUrls: ['./social-menu.component.scss']
})
export class SocialMenuComponent implements OnInit {

  modalRef: BsModalRef;
  @ViewChild('loginSignup') loginSignupTemplate: TemplateRef<any>;

  constructor(private readonly authService: AuthService, private modalService: BsModalService) { }

  ngOnInit() {
  }
  
  openSocial() {
    if(this.authService.isAuthenticated()) {
      return;
    } else {
      this.openModal();
    }
  }

  isModalOpen = false;

  openModal() {
    this.modalRef = this.modalService.show(this.loginSignupTemplate, { class: 'modal-sm modalsizecls' });
  }
  
  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }


}
